import viewport from '~/mixins/viewport'

export default {
  mixins: [viewport],

  data() {
    return {
      canShowTopStripe: true,
    }
  },

  props: {
    content: Object,
    layout: Object,
    labels: Object,
    links: Object,

    name: {
      type: String,
      required: true,
    },

    isCentered: {
      type: Boolean,
      required: true,
    },
  },
}
